const NAME = "ONBOARDING_PROCESSES_ASSIGNMENT";

export default NAME;
